import React from 'react';
import Select, { SelectProps } from 'antd/lib/select';
import { useQuery } from 'react-query';
import {
  getUserMgCompanyList,
  MGCompanyListResponse,
} from '../../services/parametersService';
import { noop } from 'lodash';

export type MGListByUserProps = SelectProps<any> & {
  userid: number;
  onChange?: any;
};

const MGListByUser = ({
  userid,
  value,
  onChange = noop,
  ...props
}: MGListByUserProps) => {
  const { data } = useQuery(
    'getUserMgCompanyList',
    () => getUserMgCompanyList({ userid }).then((res) => res.list || []),
    {
      staleTime: MINUTE,
    }
  );
  return (
    <Select
      value={value}
      onChange={(value) => onChange(value)}
      {...props}
      allowClear
    >
      {data?.map((company: MGCompanyListResponse) => (
        <Select.Option value={company.mgid} key={company.mgid}>
          {company.mgname}
        </Select.Option>
      ))}
    </Select>
  );
};

const SECOND = 1000;
const MINUTE = 60 * SECOND;

export default MGListByUser;
